export default __webpack_public_path__ + "static/media/InfoRed.14b1df1b.svg";